import { PropsWithChildren } from 'react'
import { Badge, Box, Text } from '@machobear/design-system'
import Icon from '@/components/icon'
import icons from '@/components/icon/icons'

interface Props extends PropsWithChildren {
  title: string
  icon?: keyof typeof icons
  badge?: string
}

export const SectionHeader = ({ title, icon, children, badge }: Props) => (
  <Box display="flex" flexDirection="row" justifyContent="spaceBetween" alignItems="center">
    <Box display="flex" flexDirection="row" alignItems="center" gap="xsmall">
      {icon && <Icon id={icon} width={20} height={20} />}
      <Text size="large" weight="strong" tone="formAccent">
        {title}
      </Text>
      {badge && <Badge tone="promote">{badge}</Badge>}
    </Box>

    {children}
  </Box>
)
